import * as React from 'react';

import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';

export interface CheckboxProps extends ChakraCheckbox.RootProps {
  icon?: React.ReactNode;
  indeterminate?: boolean;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  rootRef?: React.Ref<HTMLLabelElement>;
}

export type CheckedChangeDetails = Parameters<NonNullable<CheckboxProps['onCheckedChange']>>[0];

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { icon, children, inputProps, rootRef, indeterminate, ...rest } = props;

  const checkedProp = indeterminate ? 'indeterminate' : rest.checked;

  return (
    <ChakraCheckbox.Root ref={rootRef} {...rest} checked={checkedProp}>
      <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckbox.Control>{icon || <ChakraCheckbox.Indicator />}</ChakraCheckbox.Control>
      {children != null && <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>}
    </ChakraCheckbox.Root>
  );
});
